const HEIC_EXTENSIONS = ['.heic', '.heif'];
const HEIC_MIMES = ['image/heic', 'image/heif'];

export function isHeic(file: File): boolean {
  const ext = file.name.toLowerCase().slice(file.name.lastIndexOf('.'));
  return HEIC_EXTENSIONS.includes(ext) || HEIC_MIMES.includes(file.type);
}

export async function convertHeicToJpeg(file: File): Promise<File> {
  const heic2any = (await import('heic2any')).default;
  const blob = await heic2any({ blob: file, toType: 'image/jpeg', quality: 0.85 });
  const resultBlob = Array.isArray(blob) ? blob[0] : blob;
  const name = file.name.replace(/\.heic$|\.heif$/i, '.jpg');
  return new File([resultBlob], name, { type: 'image/jpeg' });
}

export async function convertHeicBatch(files: File[]): Promise<File[]> {
  const results = await Promise.allSettled(files.map(convertHeicToJpeg));
  return results.map((r, i) => (r.status === 'fulfilled' ? r.value : files[i]));
}
